import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';

export default class MwLogoBuilder extends Component {
  @tracked type = 'full';
  @tracked color = 'black';
  @tracked accent = false;
  typeOptions = ["full","icon","square"];
  colorOptions = ["black","white","grey","accent"];

  @action
  setType(value) {
    this['type'] = value;
  }

  @action
  setColor(value) {
    this['color'] = value;
  }

  @action
  setAccent(value) {
    this['accent'] = value;
  }

  @action
  resetToDefaults() {
    this['type'] = 'full';
    this['color'] = 'black';
    this['accent'] = false;
  }
}
